// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1L-GT","alertIcon":"ConfirmModal_alertIcon__wSYKK"};